module.exports = __webpack_public_path__ + "static/media/inhousenews_left.53b18a10.png";